import { render, staticRenderFns } from "./shipment-open-report.vue?vue&type=template&id=d791a41c&scoped=true"
import script from "./shipment-open-report.vue?vue&type=script&lang=js"
export * from "./shipment-open-report.vue?vue&type=script&lang=js"
import style0 from "./shipment-open-report.vue?vue&type=style&index=0&id=d791a41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d791a41c",
  null
  
)

export default component.exports